export default "__VITE_ASSET__QgNDfyyL__"